import axios from "axios";
import { BASE_URL } from "../../assets/constants";
import { createFormHeaders, createHeaders } from "../../utils/Utils";

//! Master APIs
//TODO: Brand APIs
//  Brand Create
export const createBrandAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}create-brand`, data, headers);
};
//  Brand Update
export const updateBrandAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}update-brand`, data, headers);
};
//  Brand List
export const listBrandAPI = async () => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}list-brand`, headers);
};

//TODO: Category APIs
//  Category Create
export const createCategoryAPI = async (data) => {
  const headers = createFormHeaders()
  return await axios.post(`${BASE_URL}create-category`, data, headers);
};
//  Category Update
export const updateCategoryAPI = async (data) => {
  const headers = createFormHeaders()
  return await axios.post(`${BASE_URL}update-category`, data, headers);
};
//  Category List
export const listCategoryAPI = async () => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}list-category`, headers);
};
//TODO: Unit APIs
//  Unit Create
export const createUnitAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}create-unit`, data, headers);
};
//  Unit Update
export const updateUnitAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}update-unit`, data, headers);
};
//  Unit List
export const listUnitAPI = async () => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}list-unit`, headers);
};
//TODO: Disease APIs
//  Disease Create
export const createDiseaseAPI = async (data) => {
  const headers = createFormHeaders()
  return await axios.post(`${BASE_URL}create-disease`, data, headers);
};
//  Disease Update
export const updateDiseaseAPI = async (data) => {
  const headers = createFormHeaders()
  return await axios.post(`${BASE_URL}update-diseases`, data, headers);
};
//  Disease List
export const listDiseaseAPI = async () => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}list-diseases`, headers);
};
//TODO: Product Type APIs
//  Product Type Create
export const createProductTypeAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}create-product-type`, data, headers);
};
//  Product Type Update
export const updateProductTypeAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}update-product-type`, data, headers);
};
//  Product Type List
export const listProductTypeAPI = async () => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}list-product-type`, headers);
};
//TODO: Ingredient APIs
//  Ingredient Create
export const createIngredientAPI = async (data) => {
  const headers = createFormHeaders()
  return await axios.post(`${BASE_URL}create-ingredient`, data, headers);
};
//  Ingredient Update
export const updateIngredientAPI = async (data) => {
  const headers = createFormHeaders()
  return await axios.post(`${BASE_URL}update-ingredient`, data, headers);
};
//  Ingredient List
export const listIngredientAPI = async () => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}list-ingredient`, headers);
};
//TODO: Salt APIs
//  Salt Create
export const createSaltAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}create-salt`, data, headers);
};
//  Salt Update
export const updateSaltAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}update-salt`, data, headers);
};
//  Salt List
export const listSaltAPI = async () => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}list-salt`, headers);
};
export const listTreatmentAPI = async () => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}list-treatment`, headers);
};
export const updateTreatmentAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}update-treatment`, data, headers);
};
export const updateRegisterUSerAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}update-reg-user`, data, headers);
};
export const deleteTreatmentAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}delete-treatment`, data, headers);
};
export const createTreatmentAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}create-treatment`, data, headers);
};
//TODO: Specialization APIs
//  Specialization Create
export const createSpecializationAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}create-specialization`, data, headers);
};
//  Specialization Update
export const updateSpecializationAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}update-specialization`, data, headers);
};
//  Specialization List
export const listSpecializationAPI = async () => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}list-specialization`, headers);
};
//TODO: Product APIs
//  Product Create
export const createProductAPI = async (data) => {
  const headers = createFormHeaders()
  return await axios.post(`${BASE_URL}create-product`, data, headers);
}
//  Product Update
export const updateProductAPI = async (data) => {
  const headers = createFormHeaders()
  return await axios.post(`${BASE_URL}update-product`, data, headers);
};
//  Product List
export const listProductAPI = async () => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}list-product`, headers);
};
export const productByIdAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}product-by-id`, data, headers);
};
//TODO: Banner APIs
//  Banner Create
export const createBannerAPI = async (data) => {
  const headers = createFormHeaders()
  return await axios.post(`${BASE_URL}create-banner`, data, headers);
}
//  Banner Update
export const updateBannerAPI = async (data) => {
  const headers = createFormHeaders()
  return await axios.post(`${BASE_URL}update-banner`, data, headers);
};
//  Banner List
export const listBannerAPI = async () => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}list-banner`, headers);
};
//TODO: Coupon APIs
//  Coupon Create
export const createCouponAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}create-coupon`, data, headers);
}
//  Coupon Update
export const updateCouponAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}update-coupon`, data, headers);
};
//  Coupon List
export const listCouponAPI = async () => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}list-coupon`, headers);
};
//  Coupon List
export const getAppointmentListAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}get-booking-list`, data, headers);
};



export const createDepartmentAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}create-department`, data, headers);
};
//  Unit Update
export const updateDepartmentAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}update-department`, data, headers);
};
//  Unit List
export const listDepartmentAPI = async () => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}list-department`, headers);
};
//  Unit List
export const listPrakrityQuestionsAPI = async () => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}list-prakrity-questions`, headers);
};

export const updatePrakrityCategoryAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}update-PrakritiCategory`, data, headers);
};
export const updatePrakrityQuestionAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}update-prakrity-questions`, data, headers);
};

export const createPrakrityCategoryAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}create-PrakritiCategory`, data, headers);
};
export const createPrakrityRecommendation = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}create-Prakriti-recommendation`, data, headers);
};
export const listPrakrityRecommendationAPI = async () => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}list-prakriti-recommendation`, headers);
};
export const updatePrakrityRecommndationAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}update-Prakriti-recommendation`, data, headers);
};
export const listPrakrityCategoryAPI = async () => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}list-PrakritiCategory`, headers);
};
// export const getPrakrityCategoryDDAPI = async () => {
//   const headers = createHeaders()   
//   return await axios.get(`${BASE_URL}PrakritiCategory-dd`, headers);
// };
export const getPrakrityCategoryDDAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}PrakritiCategory-dd`, data, headers);
};
export const getProductDDAPI = async () => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}product-dd`, headers);
};



export const createPrakritiQuestionAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}create-prakriti-ques`, data, headers);
};


//TODO:Disease Mapping  APIs
// Disease Mapping Create
export const createMappingAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}create-disease-mapping`, data, headers);
};
//  Mapping Update
export const updateMappingAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}update-disease-mapping`, data, headers);
};
//  Mapping List
export const listMappingAPI = async () => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}list-disease-mapping`, headers);
};

//TODO: Qualification APIs
//  Qualification Create
export const createQualificationAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}create-qualification`, data, headers);
};
//  Qualification Update
export const updateQualificationAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}update-qualification`, data, headers);
};
//  Qualification List
export const listQualificationAPI = async () => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}list-qualification`, headers);
};

//TODO: SubQualification APIs
//  SubQualification Create
export const createSubQualificationAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}create-sub-qualification`, data, headers);
};
//  SubQualification Update
export const updateSubQualificationAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}update-sub-qualification`, data, headers);
};
//  SubQualification List
export const listSubQualificationAPI = async () => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}list-sub-qualification`, headers);
};

//TODO: Diagnosis APIs
//  Diagnosis Create
export const createDiagnosisAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}create-diagnosis`, data, headers);
};
//  Diagnosis Update
export const updateDiagnosisAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}update-diagnosis`, data, headers);
};
//  Diagnosis List
export const listDiagnosisAPI = async () => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}list-diagnosis`, headers);
};

//TODO: TreatmentMapping APIs
//  TreatmentMapping Create
export const createTreatmentMappingAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}create-diagnosis-treatment`, data, headers);
};
//  TreatmentMapping Update
export const updateTreatmentMappingAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}update-diagnosis-treatment`, data, headers);
};
//  TreatmentMapping List
export const listTreatmentMappingAPI = async () => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}list-diagnosis-treatment`, headers);
};
export const deleteTreatmentMappingAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}delete-diagnosis-treatment`, data, headers);
};

//TODO: MostSearch APIs
//  TreatmentMapping Create
export const createMostSearchAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}add-most-search`, data, headers);
};
//  MostSearch Update
export const updateMostSearchAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}edit-most-search`, data, headers);
};
//  MostSearch List
export const listMostSearchAPI = async () => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}most-search`, headers);
};
export const deleteMostSearchAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}delete-most-search`, data, headers);
};
export const approveMostSearchAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}approve-most-search`, data, headers);
};

//  createMedicineAPI List
export const createMedicineAPI = async (data) => {
  const headers = createFormHeaders()
  return await axios.post(`${BASE_URL}create-admin-medicine`, data, headers);
};
//  updateMedicineAPI List
export const updateMedicineAPI = async (data) => {
  const headers = createFormHeaders()
  return await axios.post(`${BASE_URL}update-admin-medicine`, data, headers);
};
//  listMedicine List
export const listMedicineAPI = async () => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}list-medicine`, headers);
};
//  updateMedicine List
export const approveMedicineAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}approve-medicine`, data, headers);
};

//TODO: TreatmentMapping APIs
//  TreatmentMapping Create
export const createDiseaseFaqAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}create-faq`, data, headers);
};
//  DiseaseFaq Update
export const updateDiseaseFaqAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}update-faq`, data, headers);
};
//  DiseaseFaq List
export const listDiseaseFaqAPI = async () => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}list-faq`, headers);
};
export const deleteDiseaseFaqAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}delete-faq`, data, headers);
};

export const createFaqAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}create-web-faq`, data, headers);
};
//  DiseaseFaq Update
export const updateFaqAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}update-web-faq`, data, headers);
};
//  DiseaseFaq List
export const listFaqAPI = async () => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}list-web-faq`, headers);
};
export const deleteFaqAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}delete-web-faq`, data, headers);
};


//  contact List
export const listWebContactAPI = async () => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}contact-list`, headers);
};